import { useCallback, useLayoutEffect, useState } from 'react';
import useProxySrc from './business/useProxySrc';
import { getTiktokProxyImageSrc } from 'lib/utils/platformImage';

function useImageStatus(src: string, initialLoad = true) {
  const { getProxyEnable, errorLog } = useProxySrc();

  const [loaded, setLoaded] = useState(false);

  const [loading, setLoading] = useState(false);

  const [error, setError] = useState<any>();

  const [proxySrc, setProxySrc] = useState<string>();

  const hasError = Boolean(error);

  const load = useCallback(() => {
    if (!src) {
      setError(new Error('invalid src'));
      return;
    }
    const _src = !hasError && getProxyEnable(src) ? getTiktokProxyImageSrc(src) : src;
    setLoading(true);
    const image = new Image();
    image.onload = () => {
      setLoading(false);
      setLoaded(true);
      setProxySrc(_src);
      setError(undefined);
    };
    image.onerror = (err) => {
      setLoading(false);
      setError(err);
      errorLog(_src);
    };

    image.src = _src;
  }, [src, hasError, getProxyEnable, errorLog]);

  useLayoutEffect(() => {
    if (initialLoad) {
      load();
    }
  }, [initialLoad, load]);

  return {
    loading,
    error,
    loaded,
    load,
    proxySrc,
  };
}

export default useImageStatus;
